import React, { ComponentType } from 'react';
import { useUserStatus } from '@mainframe/context/user-context';
import { LoginWithWalletScreenContent } from './LoginWithWalletScreenContent';

function withWalletLoggedIn<P = unknown>(
  WrappedComponent: React.FC<any>,
): ComponentType<P> {
  const RegisteredWalletConnection = (props: P) => {
    const loginStatus = useUserStatus();

    switch (loginStatus.value) {
      case `authed`:
        return <WrappedComponent {...props} />;
      case `connected`:
      case `idle`:
      default:
        return <LoginWithWalletScreenContent />;
    }
  };

  return RegisteredWalletConnection;
}
export default withWalletLoggedIn;
